import React, { FunctionComponent } from 'react';
import Select from 'react-select';
import { TempUnitType } from '../../../../../core/src/api';

const TempUnits = [
  { label: 'Fahrenheit(°F)', value: 'fahrenheit' },
  { label: 'Celsius(°C)', value: 'celsius' },
];

type SelectProps = {
  name: string;
  selectedValue: TempUnitType;
  isDisabled?: boolean;
  onChange: (value: { value: TempUnitType; label: string }) => void;
};

export const SelectTemperatureUnit: FunctionComponent<SelectProps> = ({
  name,
  selectedValue,
  ...props
}) => {
  const defaultOption = TempUnits.find((option) => option.value === selectedValue);
  return (
    <Select options={TempUnits} name={name} value={defaultOption} isSearchable={false} {...props} />
  );
};
